
import { gql } from '../../__gql__/gql';

export const LOCATION_BY_GOOGLE_PLACE_ID = gql(`
  query LocationByGooglePlaceId($id: String!) {
    locationByGooglePlaceId(id: $id) {
      id
      hub
      address {
        formattedAddress
        countryCode
        originalAddress
      }
      position {
        lat
        lng
      }
    }
  }
`);
